import Platform from '../base';

class Browser extends Platform {}

export default Browser;
